import React from "react";

import { FiArrowLeft } from "react-icons/fi";

const AAMobilePage = ({
  selectedBankId,
  getBank,

  aaMobile,
  setAaMobile,
  aaMobileError,
  setAaMobileError,

  openAaOtpSheet,
  setScreen,
}) => {
  const selectedBank = getBank(selectedBankId);

  return (
    <section className="fw-screen fw-screen--bank fw-fade">
      <div className="fw-bank-top">
        <button
          type="button"
          className="fw-bank-back"
          onClick={() => setScreen("/apply-new/connectBank")}
          aria-label="Back"
        >
          <FiArrowLeft />
        </button>

        <h1>Account Aggregator Verification tempd </h1>
      </div>

      <div className="fw-bank-chip">
        <span
          className="fw-bank-logo fw-bank-logo--sm"
          style={{ background: selectedBank.color }}
        >
          {selectedBank.name.charAt(0)}
        </span>

        <strong>{selectedBank.name}</strong>
      </div>

      <label className="fw-field">
        <span>
          Enter the mobile number linked to your account 
        </span>

        <div className="fw-mobile-input">
          <span>🇮🇳</span>

          <strong>+91</strong>

          <i />

          <input
            type="tel"
            inputMode="numeric"
            maxLength={10}
            placeholder="Enter your mobile number"
            value={aaMobile}
            onChange={(e) => {
              setAaMobile(
                e.target.value
                  .replace(/\D/g, "")
                  .slice(0, 10)
              );

              setAaMobileError("");
            }}
          />
        </div>

        {aaMobileError && (
          <p className="fw-error">
            {aaMobileError}
          </p>
        )}
      </label>

      <div className="fw-screen__footer">
        <button
          type="button"
          className="fw-btn fw-btn--dark fw-btn--full"
          onClick={openAaOtpSheet}
        >
          Proceed
        </button>
      </div>

      <p className="fw-powered">
        Powered by <b>FUNDSWALLE</b>
      </p>
    </section>
  );
};

export default AAMobilePage;